import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import AuditLogsPage from "@/pages/admin/AuditLogsPage";

export const Route = createFileRoute("/_admin/admin/audit-logs")({
  head: () => pageHead("Admin · Audit Logs", "AKIVA admin · audit logs portal.", "/admin/audit-logs", true),
  component: AuditLogsPage,
});
